import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SearchService, SEARCH_TYPE_CUENTA, SEARCH_TYPE_LABEL, SEARCH_TYPE_CONTACTO } from '../../../../services/search-service';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MdOptionSelectionChange } from '@angular/material';

@Component({
  selector: 'app-cuentaetiqueta-autocomplete',
  templateUrl: './cuentaetiqueta-autocomplete.component.html',
  styleUrls: ['./cuentaetiqueta-autocomplete.component.scss']
})
export class CuentaEtiquetaAutocompleteComponent implements OnInit {

  @Input('placeholder') placeholder = 'Filtrar por Cuenta, Contacto o Etiqueta';
  @Input('singleValue') singleValue = false;
  @Input('hideLabelsSearch') hideLabelsSearch = false;
  @Input() disabled: boolean;

  public cuentas = [];
  public inputStateControl: FormControl;
  public filteredItems: Observable<any>;
  public selectedCuentas = [];
  public selectedEtiquetas = [];
  public selectedContactos = [];

  constructor(private searchService: SearchService) {

    this.inputStateControl = new FormControl();
    this.filteredItems = this.inputStateControl.valueChanges
        .startWith(null)
        .debounceTime(1000)
        .switchMap(value => {
          value = value && value.trim();
          value = value && value[0] === '#' && this.hideLabelsSearch ? value.slice(1) : value;
          if ( (value && value.length > 2) &&
               (!this.singleValue || this.selectedCuentas.length + this.selectedEtiquetas.length + this.selectedContactos.length === 0))
          {
            return value[0] === '@' ?
                   this.searchService.searchAutocomplete(value.slice(1), SEARCH_TYPE_CONTACTO) :
                   (value[0] === '#' && !this.hideLabelsSearch ?
                    this.searchService.searchAutocomplete(value.slice(1), SEARCH_TYPE_LABEL) :
                    this.searchService.searchAutocomplete(value, SEARCH_TYPE_CUENTA)
                   );
          } else {
            return Observable.from([]);
          }
        })
        .map( value => {
          return value;
        });
  }

  ngOnInit() {
  }

  selectedItem(event: MdOptionSelectionChange, value) {

    if (this.singleValue && this.selectedCuentas.length + this.selectedEtiquetas.length  + this.selectedContactos.length > 0){
      return;
    }

    if (event.source.selected && !value.Etiqueta && value.ClientContactId <= 0 &&
        this.selectedCuentas.filter(v => v.Id === value.Id).length === 0)
    {
        this.selectedCuentas.push(value);
    }
    else if (event.source.selected && value.Etiqueta &&
             this.selectedEtiquetas.filter(v => v.Id === value.Id).length === 0)
    {
      this.selectedEtiquetas.push(value);
    }
    else if (event.source.selected && value.ClientContactId > 0 &&
             this.selectedContactos.filter(v => v.ClientContactId === value.ClientContactId).length === 0)
    {
      this.selectedContactos.push(value);
    }
  }

  removeItem(item){
    if (!item.Etiqueta && item.ClientContactId <= 0) {
      this.selectedCuentas.splice(this.selectedCuentas.findIndex(v => v.Id === item.Id), 1);
    } else if (item.Etiqueta) {
      this.selectedEtiquetas.splice(this.selectedEtiquetas.findIndex(v => v.Id === item.Id), 1);
    } else {
      this.selectedContactos.splice(this.selectedContactos.findIndex(v => v.ClientContactId === item.ClientContactId), 1);
    }
  }

  displayFn(value){
    return null;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/cuentaetiqueta-autocomplete/cuentaetiqueta-autocomplete.component.ts